<template>
  <div class="form-group">
    <label :for="elementId" class="control-label">Select Page</label>
    <select :id="elementId" class="form-control page-lookup" style="width: 100%"></select>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'

const props = defineProps({
  idIndex: {
    type: String,
    default: ''
  },
  apiUrl: {
    type: String,
    default: '/api/pages'
  }
})
const emit = defineEmits(['update:modelValue', 'handleChange'])

const elementId = ref(props.idIndex ? `page-lookup-select-${props.idIndex}` : 'page-lookup-select')

onMounted(() => {
  $(() => {
    const $selectEl = $(`#${elementId.value}`)
    $selectEl.select2({
      ajax: {
        url: props.apiUrl,
        dataType: 'json',
        data: function (params) {
          return {
            search: params.term
          }
        },
        processResults: function (data) {
          return {
            results: data.data.map((item) => {
              return {id: item.id, text: `${item.name} - (${item.id})`}
            })
          }
        }
      }
    })
    $selectEl.on('change', function () {
      let selected = $selectEl.select2('data')
      if (selected && selected[0]) {
        emit('handleChange', selected[0])
      }
    })
  })
})
</script> 